import React, { Component } from 'react';
import { Button, AutoComplete, Input } from 'antd';
import { Plus, Search, Tags, ChartColumn } from 'lucide-react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import TagsController from './tags.controller';
import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader, FilterBar, FilterField } from '../common';
import { TagsTable, TagFormModal, TagAssignmentModal, SOSAnalysisModal, TagAnalytics } from './elements';
import { isScreenEnabled } from '../../company/session';

class ShelfTags extends Inherit(TagsController, Component) {
    state = {
        loading: true,
        tags: [],
        searchText: '',
        formModalVisible: false,
        assignmentModalVisible: false,
        sosModalVisible: false,
        selectedTag: null,
        filterModelType: null,
        filterHasSOS: null
    };

    render() {
        const { tags, loading, searchText, formModalVisible, assignmentModalVisible, sosModalVisible, selectedTag, filterHasSOS } = this.state;
        const sosOnly = filterHasSOS === true;

        return (
            <Layout current="tags">
                {this.props.contextHolder}

                <PageHeader
                    icon={<Tags />}
                    title="Sistema de Etiquetas"
                    description="Organiza y clasifica elementos con etiquetas personalizadas"
                    actions={
                        <Button type="primary" icon={<Plus />} onClick={this.handleCreate.bind(this)}>
                            Nueva Etiqueta
                        </Button>
                    }
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={4} />
                        <TableSkeleton rows={10} columns={6} />
                    </div>
                ) : (
                    <div className="space-y-4">
                        <TagAnalytics tags={tags} />

                        <FilterBar className="!mb-0">
                            <FilterField label="Buscar" className="w-full sm:w-72">
                                <AutoComplete
                                    value={searchText}
                                    options={tags.map((t) => ({ value: t.name }))}
                                    onSearch={(value) => this.setSearchText(value)}
                                    onSelect={(value) => this.selectSearch(value)}
                                    onChange={(value) => this.setSearchText(value)}
                                    className="w-full">
                                    <Input
                                        placeholder="Buscar etiqueta..."
                                        prefix={<Search className="text-surface-400" />}
                                        allowClear
                                        onPressEnter={this.handleSearch.bind(this)}
                                    />
                                </AutoComplete>
                            </FilterField>

                            <Button
                                onClick={() => this.toggleSOSFilter()}
                                color={sosOnly ? 'primary' : 'default'}
                                variant={sosOnly ? 'filled' : 'outlined'}
                                aria-pressed={sosOnly}
                                icon={<ChartColumn />}>
                                {sosOnly ? 'Mostrar Todas' : 'Con SOS'}
                            </Button>
                        </FilterBar>

                        <TagsTable
                            tags={tags}
                            loading={loading}
                            onEdit={this.handleEdit.bind(this)}
                            onDelete={this.handleDelete.bind(this)}
                            onAssign={this.handleAssign.bind(this)}
                            // The link opens the SOS analysis screen: only for companies that have it.
                            onViewSOS={isScreenEnabled('sos-analysis') ? this.handleViewSOS.bind(this) : undefined}
                        />
                    </div>
                )}

                {/* Modals */}
                {formModalVisible && (
                    <TagFormModal
                        visible={formModalVisible}
                        tag={selectedTag}
                        onSuccess={this.handleFormSuccess.bind(this)}
                        onCancel={() => this.setFormModalVisible(false)}
                        onMessage={this.props.onMessage}
                    />
                )}

                {assignmentModalVisible && (
                    <TagAssignmentModal
                        visible={assignmentModalVisible}
                        tag={selectedTag}
                        onSuccess={this.handleAssignmentSuccess.bind(this)}
                        onCancel={() => this.setAssignmentModalVisible(false)}
                        onMessage={this.props.onMessage}
                    />
                )}

                {sosModalVisible && <SOSAnalysisModal visible={sosModalVisible} tag={selectedTag} onCancel={() => this.setSOSModalVisible(false)} />}
            </Layout>
        );
    }
}

export default withNavigate(ShelfTags);
